module.exports = ".comentarios {\n  max-width: 40%; }\n\n.money {\n  width: 10%; }\n\n.date {\n  width: 10%; }\n\n.name {\n  width: 15%; }\n\n.status {\n  width: 15%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/approval-committee/approval-committee.component.scss
// module id = ./src/app/limit-flow-proposal/component/approval-committee/approval-committee.component.scss
// module chunks = main